import React from "react";
import { Box, Text } from "@chakra-ui/react";
import { TextTitle } from "ui/text";
import { Diptych, DiptychColumn, type DiptychProps } from "ui/diptych";
import { DeterministicAnimation } from "./deterministic-animation";
import { ProbabilisticAnimation } from "./probabilistic-animation";

const diptychProps: Pick<DiptychProps, "theme" | "direction" | "size" | "titleAs" | "maxW"> = {
  theme: "dark",
  direction: "right",
  size: "lg",
  titleAs: "h3",
};

function StyledTitle({ children }: { children: React.ReactNode }) {
  return (
    <Text as="span" textStyle={{ base: "headline3", sm: "headline2", lg: "display3" }}>
      {children}
    </Text>
  );
}

export function IdrMatching() {
  return (
    <Box as="section" maxW={{ base: "680px", md: "100%" }} mx="auto">
      <TextTitle
        theme="dark"
        size="lg"
        maxW="4xl"
        descriptionMaxW="2xl"
        align="center"
        title="Choose your confidence level with Adaptive Identity Resolution"
        description="Some use cases, like transactional emails, work best with high-confidence deterministic matching. Others, like ad targeting, work best with high-reach probabilistic matching. With Hightouch, you can use the right method for the right use case."
      />

      <DiptychColumn mt="bigger">
        <Diptych
          {...diptychProps}
          title={<StyledTitle>Deterministic matching</StyledTitle>}
          description="Unify profiles by choosing exact matches of identifiers like email addresses or phone numbers."
          media={<DeterministicAnimation />}
          mediaRatio={814 / 635}
        />

        <Diptych
          {...diptychProps}
          title={<StyledTitle>Probabilistic matching</StyledTitle>}
          description="Build on top of your exact matches by using AI to unify more profiles, even when customer data gets messy."
          media={<ProbabilisticAnimation />}
          mediaRatio={912 / 640}
        />
      </DiptychColumn>
    </Box>
  );
}
